<div fxLayout="column" fxLayoutAlign="center center">
    <h1 class="mat-headline">{{'agent-crediting'| translate}}</h1>
  </div>
  <mat-progress-bar mode="indeterminate" *ngIf="!isCompleted"></mat-progress-bar>
  <div *ngIf="isCompleted">
    <form [formGroup]="creditForm" novalidate (ngSubmit)="update(creditForm.value)">
        <mat-dialog-content class="mat-typography">
            <h3 *ngIf="item">{{'agent' | translate}} : {{item.agent.company}}</h3>
            
            <mat-form-field fxFill>
                <input matInput type="text" placeholder="{{'credit-sum' | translate}}" formControlName="creditSum" currencyMask>

                <mat-error *ngIf="creditForm.controls['creditSum'].hasError('required')">
                    {{'credit-sum-is-req' | translate}}
                </mat-error>
            </mat-form-field>

            <mat-form-field fxFill>
                <textarea matInput placeholder="{{'comment' | translate}}" formControlName="comment"></textarea>
            </mat-form-field>
  
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>{{'cancel'| translate}}</button>
            <button mat-flat-button color="primary" type="submit" [disabled]="!creditForm.valid || inProgressTransfer == true"
                [mat-dialog-close]="true">{{'save'| translate}}</button>
        </mat-dialog-actions>
    </form>
  </div>